import React from "react"
import { Outlet, useParams } from "react-router-dom"
import { Loader } from "src/components/global/Loader"
import { ModuleErrors } from "src/components/ui/ModuleErrors"
import { useActions, useAppState } from "src/state"

export function SuperAdminVenueBookingLayout() {

    const { bookingId } = useParams()

    const { loading, currentItem, errors } = useAppState().bookings
    const { subscribeToItem, unsubscribeFromItem } = useActions().bookings

    React.useEffect(() => {
        subscribeToItem({ id: bookingId });
        return () => {
            unsubscribeFromItem()
        }
    }, [bookingId, subscribeToItem, unsubscribeFromItem])

    if (loading) return <Loader />
    if (!currentItem) return <Loader />

    return (
        <React.Fragment>
            <ModuleErrors errors={errors} />
            <Outlet/>
        </React.Fragment>
    )

}